import { Inject, Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router'
import { Observable } from 'rxjs'
import { SeAuthService, SeEnvironmentUrlService } from 'se-fe-auth-support'
import { WINDOW } from 'se-fe-domain-environment'

import { QueryString } from './query-string'

@Injectable({
  providedIn: 'root',
})
export class GuardianInviteGuardService implements CanActivate, CanActivateChild {
  private _window?: Window

  constructor(
    public authService: SeAuthService,
    private urlService: SeEnvironmentUrlService,
    @Inject(WINDOW) private windowRef: any
  ) {
    this._window = windowRef as Window
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const returnURL = this.makeURL(route)
    const emailAddress = route.queryParams.email_address
    return new Observable<boolean>((observer) => {
      this.authService
        .isAuthenticated()
        .then((authenticated) => {
          observer.next(authenticated)
          observer.complete()
          if (!authenticated) {
            this.initiateLogin(returnURL, emailAddress)
          }
        })
        .catch((e) => this.initiateLogin(returnURL, emailAddress))
    })
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state)
  }

  public makeURL(route: ActivatedRouteSnapshot): string {
    const qs = QueryString.build(route.queryParamMap)
    const path = `/setup/${ this.getDescendentPath(route) }`
    return qs.length === 0 ? path : `${ path }?${ qs }`
  }

  private initiateLogin(returnURL: string, emailAddress: string) {
    const queryParams: any = {
      user_return_to: returnURL,
      email_address: emailAddress
    }
    const redirectUrl = `${ this.urlService.getUserServiceUrl() }users/sign_in?${ QueryString.build(
      queryParams
    ) }`

    this._window.location.href = redirectUrl
  }

  private getDescendentPath(route: ActivatedRouteSnapshot): string {
    if (!route.children?.length) return route.url.map(seg => seg.path).join('/')
    return [
      route.url.map(seg => seg.path).join('/'),
      route.children.map(child => this.getDescendentPath(child)).join('/')
    ].filter(path => path.length > 0).join('/')
  }
}
